import { render, staticRenderFns } from "./ReceiptDetails.vue?vue&type=template&id=f09db43e&scoped=true"
import script from "./ReceiptDetails.vue?vue&type=script&lang=js"
export * from "./ReceiptDetails.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDetails.vue?vue&type=style&index=0&id=f09db43e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f09db43e",
  null
  
)

export default component.exports